import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { CampaniasGlobalService } from '../../../services/global-campanias.service';
import { EnumSiNoTodos, FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { catchError, of, tap } from 'rxjs';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { TwSolicitudCamViewModelBase, equalObjects } from '../../../types/solicitudcam-datosbasicos.types';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { NavMenuService } from 'src/app/components/core/components/navmenu/navmenu.service';
import { BuscadorUnidadInspeccionService } from '../buscador-unidad-inspeccion.service';
import {
    FilterSearchingRecintoUnidadInspeccion,
    RecintoUnidadInspeccionItemResultsViewModel,
    RecintoUnidadInspeccionItemViewModel,
} from '../buscador-unidad-inspeccion.types';
import { ActivaSelected, CASelectedViewModel, PeriodoDatosCaCamViewModel } from '../../solicitudes/buscador-solicitud-cam.types';
import { Mixin } from 'ts-mixer';
import { CampaniaBase } from '../../../types/campaniaBase';
import { CampaniasService } from 'src/app/components/core/_infrastructure/classes/services/campanias-global.service';
import { PeriodoCamItemViewModel, PeriodoCamViewModel } from 'src/app/components/_mantenimiento/campanias/periodos/datosbasicos/periodocam.types';
import { EnumIdsTcEstadoUnidadInspeccion, EnumIdsTcTipoSolicitudCam, EnumTcEstadoUnidadInspeccion } from '../../../types/enum';
import { PeriodoCamService } from 'src/app/components/_mantenimiento/campanias/periodos/datosbasicos/periodocam.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { InspeccionUiService } from '../../../unidades-inspeccion/inspeccion-ui.service';
import { ConfigurationService } from 'src/app/components/core/_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-buscador-unidad-inspeccion-wrapper',
    templateUrl: './buscador-unidad-inspeccion-wrapper.component.html',
    styleUrls: ['./buscador-unidad-inspeccion-wrapper.component.scss'],
})
export class BuscadorUnidadInspeccionWrapperComponent extends Mixin(ComponentBase, CampaniaBase) implements OnInit {
    spinnerExport = false;
    isTesting = false;
    searching = false;
    result: RecintoUnidadInspeccionItemResultsViewModel | null;
    payload?: FilterSearchingRecintoUnidadInspeccion;
    formGroup: FormGroup;
    activa = EnumSiNoTodos.TODOS;
    campanias: Tc[] = [];
    periodos: PeriodoCamItemViewModel[] = [];
    tiposSolicitud: Tc[] = [];
    operadores: Tc[] = [];
    CAs: PeriodoDatosCaCamViewModel[] = [];
    estadosUnidadInspeccion: Tc[] = [];
    EAs: Tc[] = [];

    // Recinto/Almacén Detail view params
    recintoDetailVisible = false;
    almacenDetailVisible = false;
    empresaDetailVisible = false;

    recintoPIAIdSelected: number | null;

    ID_SIN_ASIGNAR = EnumIdsTcEstadoUnidadInspeccion.ID_SIN_ASIGNAR;
    ID_ESTADO_BAJA = EnumIdsTcEstadoUnidadInspeccion.ID_BAJA;
    ID_ESTADO_SUSPENDIDA = EnumIdsTcEstadoUnidadInspeccion.ID_SUSPENDIDA;

    SIN_ASIGNAR = EnumTcEstadoUnidadInspeccion.SIN_ASIGNAR;
    BAJA = EnumTcEstadoUnidadInspeccion.BAJA;
    SUSPENDIDA = EnumTcEstadoUnidadInspeccion.SUSPENDIDA;

    private environment: string;
    private testingEnabled: boolean;

    constructor(
        private fb: FormBuilder,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalCampaniasService: CampaniasGlobalService,
        protected globalService: GlobalService,
        protected campaniasService: CampaniasService,
        private buscadorUnidadInspeccionService: BuscadorUnidadInspeccionService,
        private navMenuService: NavMenuService,
        private router: Router,
        private periodoCamService: PeriodoCamService,
        // Servicios para testing
        private confirmationService: ConfirmationService,
        private inspeccionUIService: InspeccionUiService,
        protected configurationService: ConfigurationService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.getEnvData();
        this.createForm();
        this.loadListsForFilters();
        setTimeout(() => {
            this.recoverLastSearch();
        }, 200);
    }

    private createForm(): void {
        this.formGroup = this.fb.group({
            Activa: EnumSiNoTodos.TODOS,
            IdCampania: null,
            IdPeriodo: null,
            IdCA: null,
            IdEntidadAuditora: null,
            CodigoUhc: '',
            NumeroRegistro: '',
            RegistroSanitario: '',
            IdTipoSolicitudCam: null,
            IdEstadoUnidadInspeccion: null,
            IdOperador: null,
            IdProvincia: null,
            IdMunicipio: null,
            Poligono: null,
            Parcela: null,
            Recinto: null,
            // NOT VISIBLE
            IdUsuario: 0, // Este valor se establece en el core
        });
        this.form = this.formGroup;
    }

    private getEnvData(): void {
        this.configurationService.getEnvironment().subscribe(res => {
            this.environment = res;
            if (this.environment === 'Desarrollo') {
                this.configurationService.getTestingEnabled().subscribe(res => {
                    this.testingEnabled = res === 'true';
                });
            }
        });
    }

    private loadListsForFilters(): void {
        this.getTiposSolicitudCam();
        this.getEstadosUnidadInspeccion();
        const activaSelected: ActivaSelected = { Activa: this.activa, cleanDependent: false };
        this.onActivaSelected(activaSelected);
    }

    private getTiposSolicitudCam(): void {
        this.globalService.getTipoSolicitudCam().subscribe(res => {
            this.tiposSolicitud = res;
        });
    }

    getOperadores(): void {
        const formModel = { ...this.form.getRawValue() } as FilterSearchingRecintoUnidadInspeccion;

        const finalModel = {
            IdCampania: formModel.IdCampania,
            IdPeriodo: formModel.IdPeriodo,
            IdCA: formModel.IdCA,
            IdEntidadAuditora: formModel.IdEntidadAuditora || null,
            IdTipoSolicitudCam: formModel.IdTipoSolicitudCam,
        };

        this.buscadorUnidadInspeccionService.getRecintoUIOperadores(finalModel).subscribe(res => {
            this.operadores = res;
        });
    }

    private getEstadosUnidadInspeccion(): void {
        this.globalCampaniasService.getEstadosUnidadInspeccion().subscribe(res => {
            // No mostramos en el desplegable la opción eliminada.
            this.estadosUnidadInspeccion = res
                ?.filter(estado => estado.Id !== EnumIdsTcEstadoUnidadInspeccion.ID_ELIMINADA)
                .sort((estado1, estado2) => {
                    if (estado1.Descripcion > estado2.Descripcion) {
                        return 1;
                    } else if (estado1.Descripcion < estado2.Descripcion) {
                        return -1;
                    }
                    return 0;
                });
        });
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch() {
        this.payload = this.buscadorUnidadInspeccionService.getLastSearch();
        if (this.payload) {
            const activaSelected: ActivaSelected = { Activa: this.activa, cleanDependent: false };
            this.onActivaSelected(activaSelected);
            this.onSearch(this.payload);
        }
    }

    private getEveryCA(): void {
        this.globalService.getComunidadesAutonomas().subscribe((comunidades: Tc[]) => {
            this.CAs = comunidades?.map(val => {
                const ca = new PeriodoDatosCaCamViewModel();
                ca.IdCa = val.Id;
                ca.ComunidadAutonoma = val.Descripcion;
                return ca;
            });
            if (this.CAs.length > 0) {
                const caSelectedViewModel = new CASelectedViewModel();
                let IdCa = 0;
                if (this.isCA) {
                    IdCa = this.loggedInUser?.TwUsuarioCa?.IdCa || 0;
                } else {
                    IdCa = this.payload?.IdCA || 0;
                }
                caSelectedViewModel.idCA = this.CAs.filter(ca => ca.IdCa === IdCa)?.at(0)?.IdCa || 0; // Si el usuario es CA, solo tendrá 1 CA en el desplegable.
                this.onCASelected(caSelectedViewModel);
            }
        });
    }

    onActivaSelected(event$: ActivaSelected): void {
        this.activa = event$.Activa;
        if (this.activa === null) {
            this.activa = EnumSiNoTodos.TODOS;
        }
        this.getCampanias(this.activa);
    }

    private getCampanias(habilitados: EnumSiNoTodos): void {
        this.campanias = [];
        this.onCampaniaSelected(this.payload?.IdCampania || 0);
        if (habilitados === null) {
            return;
        }
        this.globalCampaniasService.getCampaniasEnPeriodo(habilitados).subscribe(res => {
            this.campanias = [...res];
        });
        /*
        this.globalCampaniasService.getCampaniasByProfile(activa).subscribe(res => {
            this.campanias = [...res];
        });
        */
    }

    onCampaniaSelected(idCampania?: number): void {
        this.getPeriodos(idCampania);
    }

    private getPeriodos(idCampania?: number): void {
        this.periodos = [];
        this.onPeriodoSelected(this.payload?.IdPeriodo || 0);
        if (!idCampania) {
            return;
        }

        this.globalCampaniasService.getPeriodosByCampaniaCompleta(idCampania, this.activa).subscribe(res => {
            this.periodos = [...res];
        });
    }

    onPeriodoSelected(idPeriodo?: number): void {
        this.getCAs(idPeriodo);
    }

    private getCAs(idPeriodo?: number): void {
        this.CAs = [];
        this.getOperadores();
        if (!idPeriodo) {
            this.getEveryCA();
            this.onCASelected(new CASelectedViewModel());
            return;
        }
        this.globalCampaniasService.getCAsByPeriodo(idPeriodo).subscribe(res => {
            this.CAs = [...res];
            // Disparamos CaSelected cuando el usuario es CA, porque no se "pinta" el desplegable de CAs en pantalla.
            // de otra forma, nunca se cargarían en pantalla los dependendientes de la CA.
            if (this.CAs.length > 0) {
                const caSelectedViewModel = new CASelectedViewModel();
                let IdCa = 0;
                if (this.isCA) {
                    IdCa = this.loggedInUser?.TwUsuarioCa?.IdCa || 0;
                } else {
                    IdCa = this.payload?.IdCA || 0;
                }
                caSelectedViewModel.idCA = this.CAs.filter(ca => ca.IdCa === IdCa)?.at(0)?.IdCa || 0; // Si el usuario es CA, solo tendrá 1 CA en el desplegable.
                caSelectedViewModel.idPeriodo = idPeriodo;
                this.onCASelected(caSelectedViewModel);
            }
        });
    }

    onCASelected(param$: CASelectedViewModel): void {
        this.EAs = [];
        this.getProvincias(param$);
        this.onProvinciaSelected(this.payload?.IdProvincia || 0);

        if (!param$?.idPeriodo || !param$?.idCA) {
            return;
        }

        this.globalCampaniasService.getEAsByCA(param$).subscribe(res => {
            this.EAs = res;
        });
    }

    private getProvincias(param$: CASelectedViewModel): void {
        const promiseAmbitoNacional = () => {
            return new Promise(resolve => {
                if (!param$?.idPeriodo) {
                    if (param$?.idCA) {
                        resolve(true); // cargamos provincias por CA.
                        return;
                    }
                    resolve(false);
                    return;
                }

                if (!this.periodos || this.periodos.length === 0) {
                    // @author: scalero1 - Al obtener el periodo, tendremos que traernos tb la propiedad que indica si es de ámbito nacional
                    this.periodoCamService
                        .getById(param$.idPeriodo!)
                        .pipe(
                            tap((p: PeriodoCamViewModel) => {
                                resolve(p.AmbitoNacional);
                            }),
                            catchError(() => {
                                resolve(false);
                                return of(false);
                            }),
                        )
                        .subscribe();
                } else {
                    const ambitoNacional = this.periodos.find(x => x.Id === param$.idPeriodo)?.AmbitoNacional || false;
                    resolve(ambitoNacional);
                }
            });
        };

        promiseAmbitoNacional().then((res: any) => {
            if (!this.filtroBase) {
                this.filtroBase = new TwSolicitudCamViewModelBase();
            }
            this.filtroBase.AmbitoNacional = res;
            this.filtroBase.IdCa = param$?.idCA || 0;
            this.filtroBase.IdPeriodoCam = param$?.idPeriodo || 0;

            this.loadProvincias();
        });
    }

    /**
     * Respond to the action of searching on "buscador-unidad-inspeccion-filter".
     * It will send the filter to the backend and set the response.
     * If the search comes from the "filter" component, the fields related to the pagination will be reset.
     * In the search comes from the "list-paginator" component case the search params remain the same.
     * @param payload FilterSearchingRecintoUnidadInspeccion
     * @return void
     */
    onSearch(payload: FilterSearchingRecintoUnidadInspeccion): void {
        this.navMenuService.clearMenuServiceForUdInspeccion();
        if (!equalObjects(this.payload, payload)) {
            // As soon as the user changes the "filter", the previous payload pagination values have no sense
            // When recovering the request params from the last result, the pagination params won't be reset.
            payload = this.clearPaginationFilter(payload);
        }

        this.payload = { ...payload } as FilterSearchingRecintoUnidadInspeccion; // To keep a copy to be used in the lazy search (paginator)
        if (!payload) {
            return;
        }

        if (this.payload.Activa === null) {
            this.payload.Activa = EnumSiNoTodos.TODOS;
        }

        this.searching = true;
        // @author: scalero1 - Aunque en el payload aparezcan 0s en los campos IdCA o IdEntidadAuditora,
        // en el core se establecen sus respectivos Ids para los usuarios CA o EA.
        this.buscadorUnidadInspeccionService
            .getRecintoUnidadesInspeccion(this.payload)
            .pipe(
                tap(results => {
                    this.result = results as RecintoUnidadInspeccionItemResultsViewModel;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of([]);
                }),
            )
            .subscribe();
    }

    /**
     * We don't clear the whole filter but only the fields related to the pagination.
     */
    private clearPaginationFilter(payload: FilterSearchingRecintoUnidadInspeccion): FilterSearchingRecintoUnidadInspeccion {
        if (!payload) {
            return payload;
        }
        payload.PageNumber = 0;
        payload.Asc = 0;
        payload.OrderBy = '';
        return payload;
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        this.payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingRecintoUnidadInspeccion;
        this.onSearch(this.payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onReset(): void {
        this.searching = false;
        this.result = null;
        this.activa = EnumSiNoTodos.TODOS;
        const activaSelected: ActivaSelected = { Activa: this.activa, cleanDependent: true };
        this.onActivaSelected(activaSelected);
        this.buscadorUnidadInspeccionService.resetFilter();
        this.navMenuService.clearMenuServiceForUdInspeccion();
    }

    /**
     * Redirigimos al formulario de creación de una nueva Unidad de Inspección
     * @return void
     */
    onAdd(): void {
        this.router.navigate(['/campanias/unidadinspeccion/datosbasicos/create']);
    }

    /**
     * Redirigimos al formulario de edición de la Unidad de Inspección.
     * Cuando el parámetro sea null, el backend captura el error y se muestra en pantalla.
     * @param itemId number|null
     * @return void
     */
    onEdit(itemId: number | null): void {
        this.router.navigate(['/campanias/unidadinspeccion/datosbasicos/detail', itemId]);
    }

    /**
     * Si el objeto tiene Id, redirigimos al formulario de edición de la Unidad de Inspección, pero en modo consulta.
     * Si no tiene Id, se mostrará una ventana popup con el detalle del recinto o del almacén, según corresponda.
     * @param itemId RecintoUnidadInspeccionItemViewModel
     * @return void
     */
    onView(item: RecintoUnidadInspeccionItemViewModel): void {
        if (item.IdUi) {
            this.router.navigate(['/campanias/unidadinspeccion/datosbasicos/detail', item.IdUi]);
        } else if (item.IdTipoSolicitudCam === EnumIdsTcTipoSolicitudCam.ID_INVERNADERO || item.IdTipoSolicitudCam === EnumIdsTcTipoSolicitudCam.ID_PARCELA) {
            // Abrir detalle recinto
            this.recintoPIAIdSelected = item.Cultivo.IdRecinto;
            this.recintoDetailVisible = true;
        } else if (item.IdTipoSolicitudCam === EnumIdsTcTipoSolicitudCam.ID_CONFECCION) {
            // Abrir detalle almacén
            this.recintoPIAIdSelected = item.Almacen.Id!;
            this.almacenDetailVisible = true;
        } else if (item.IdTipoSolicitudCam === EnumIdsTcTipoSolicitudCam.ID_EMPRESA_DESHIDRATACION) {
            // Abrir detalle de Empresa Deshidratadora
            this.recintoPIAIdSelected = item.EmpresaDeshidratadora.Id!;
            this.empresaDetailVisible = true;
        }
    }

    /**
     * Se captura el evento que indica que la ventana de diálogo que muestra el detalle del recinto
     * se ha cerrado.
     * @param $event any
     */
    onRecintoDialogClosed($event: any): void {
        this.recintoDetailVisible = false;
        this.almacenDetailVisible = false;
        this.empresaDetailVisible = false;
    }

    /**
     * Invoked when the user wants to export the result to excel
     * @return void
     */
    onExportExcel(): void {
        this.spinnerExport = true;

        let model: FilterSearchingRecintoUnidadInspeccion = new FilterSearchingRecintoUnidadInspeccion();
        Object.assign(model, this.payload);

        this.buscadorUnidadInspeccionService.export(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.spinnerExport = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    get exportIsAvailable(): boolean {
        const hasAccess = this.loggedInUser?.getAction(EnumCodigosTwTcAcciones.EXPORT_UDS_INSPECCION).Editable || false;
        return hasAccess && this.result?.ResultList ? this.result?.ResultList?.length > 0 : false;
    }

    get allowNueva(): boolean {
        return this.loggedInUser?.getAction(EnumCodigosTwTcAcciones.NUEVA_UD_INSPECCION).Editable || false;
    }

    ///////////////////////////////////////////////////////////////////////////
    //// MÉTODOS EXCLUSIVOS DE TESTING
    ///////////////////////////////////////////////////////////////////////////

    get isTestingVisible(): boolean {
        return this.isAdmin && this.environment === 'Desarrollo' && this.testingEnabled;
    }

    testTransiciones(): void {
        this.confirmationService.confirm({
            message: 'Se va a realizar el test de transiciones de estado, ¿está seguro?',
            accept: () => {
                this.doTestTotal();
                // this.doTestTransicionesUnitario();
            },
        });
    }

    private doTestTransicionesUnitario(): void {
        this.isTesting = true;
        this.inspeccionUIService
            .testTransicionesPreinscrita()
            .pipe(
                tap(res => {
                    this.isTesting = false;
                    this.addSuccessMessage('Test terminado');
                }),
                catchError(error => {
                    this.isTesting = false;
                    return of(null);
                }),
            )
            .subscribe();
    }

    private doTestTotal(): void {
        this.isTesting = true;
        this.inspeccionUIService
            .testTransiciones()
            .pipe(
                tap(res => {
                    this.isTesting = false;
                    this.addSuccessMessage('Test terminado');
                    this.OpenDownloadedFile(res);
                }),
                catchError(error => {
                    this.isTesting = false;
                    this.OpenDownloadedFile(error);
                    return of(null);
                }),
            )
            .subscribe();
    }
}
